import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import { AppContext } from "../../context/AppContext/AppContext";

import { getInfoPatient } from "../../services/common/admin";
import { removeItem } from "../../services/localStorage";

import Input from "../../atoms/Input";
import Spinner from "../../atoms/Spinner";
import { Button } from "../../atoms/Button/";
import ErrorMessage from "../../atoms/ErrorMessage";
import SelectOption from "../../atoms/SelectOption";

import styles from "./LoginPatientsForm.module.scss";

export default function LoginPatientsForm() {
  const navigate = useNavigate();
  const { patientDocument, setUserInfo, options } = useContext(AppContext);
  const [charging, setCharging] = useState(false);
  const [customError, setCustomError] = useState("");
  const devEnv =
    window.location.origin.indexOf("dev") > -1 ||
    window.location.origin.indexOf("localhost") > -1;
  const [isDev] = useState(devEnv);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setCustomError(""), 4000);
    return () => clearTimeout(timer);
  }, [customError]);

  return (
    <div className={styles.container}>
      <Formik
        initialValues={{
          documentType: "CC",
          documentNumber: "",
        }}
        validationSchema={Yup.object({
          documentNumber: Yup.string()
            .required("Por favor digita un número de documento"),
        })}
        onSubmit={async (values) => {
          if (patientDocument && patientDocument !== values.documentNumber) {
            setCustomError(
              "El documento no pertenece al paciente de la escala a diligenciar"
            );
            return;
          }
          if (patientDocument) removeItem("document");
          setIsLoading(true);
          if (charging) return;
          setCharging(true);

          const payload = {
            doc: values.documentNumber,
            tdoc: options.find((option) => option.value === values.documentType)
              .id,
          };

          const response = await getInfoPatient(payload);

          if (response.data.data.response.length) {
            setIsLoading(false);
            setUserInfo(response.data.data.response[0]);
            navigate("/loginAuth");
          } else {
            setCustomError(
              "Los datos ingresados no están registrados, inténtalo nuevamente"
            );
            setIsLoading(false);
          }

          setCharging(false);
        }}
      >
        {() => (
          <Form>
            <div className={styles.loginForm}>
              <SelectOption
                label="Tipo de documento"
                name="documentType"
                id="documentType"
                classNameL={styles.loginLabel}
              >
                <option value="" disabled selected>
                  Seleccionar
                </option>
                {options.map(({ value, label }) => (
                  <option value={value} key={value}>
                    {label}
                  </option>
                ))}
              </SelectOption>
              <Input
                label="Número de documento"
                name="documentNumber"
                type="text"
                classNameL={styles.loginLabel}
              />
              <div className={styles.anchorContainer}>
                <a
                  href="https://fundacionsantafedebogota.com/terminos-y-condiciones"
                  target="__blank"
                  className={styles.anchor}
                >
                  Términos y condiciones
                </a>
                <a
                  href="https://fundacionsantafedebogota.com/politica-tratamiento-datos-personales"
                  className={styles.anchor}
                  target="__blank"
                >
                  Política de tratamiento de datos
                </a>
              </div>
              <ErrorMessage error={customError} />
              <div className={styles.buttonContainer}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={charging}
                  className={styles.buttonSend}
                >
                  Continuar
                </Button>
              </div>
              {isLoading ? (
                <div className={styles.spinnerContainer}>
                  <Spinner
                    className_img="logPatientImg"
                    className_container="logPatientCont"
                  />
                </div>
              ) : null}
            </div>

            {/* {isDev && (
                  <div styles={{ color: "gray", fontSize: "smaller" }}>
                    Documento válido: {patientDocument}
                  </div>
                )} */}
          </Form>
        )}
      </Formik>
    </div>
  );
}
